import { useEntityIdSelector } from '../../../redux/entity-id-selector.hook';
import { projectAPI } from '../redux/projects.slice';

export function useProject(id: string | null | undefined) {
  const { entity: project } = useEntityIdSelector(projectAPI, id);
  return { project };
}
